// F20 (2026-09-28): how PersonaAssessmentFlow reads the notify-next reply. The route answers HTTP
// 200 with `success:false` when the next persona could not be notified (e.g. nobody was invited),
// so "sent" must come from the body, never from the status code alone. Fails closed.
interface NotifyNextBody {
  success?: boolean;
  message?: string;
  error?: string; // the route's 500 path answers { success:false, error }
  data?: { notificationResult?: { error?: string } };
}

export function notifyNextOutcome(httpOk: boolean, body: NotifyNextBody | null | undefined): { sent: boolean; reason: string | null } {
  if (httpOk && body?.success === true) return { sent: true, reason: null };
  return { sent: false, reason: body?.message ?? body?.error ?? body?.data?.notificationResult?.error ?? null };
}
